<template>
    <div class="container-box">
        <div class="text">
            {{ $t('referralForm.instructions') }}
        </div>
        <div class="form">
            <div v-show="submissionError" class="error">{{ submissionError }}</div>
            <b-form-input
                v-model="form.fullName"
                type="text"
                class="input-control"
                required
                size="lg"
                :placeholder="$t('referralForm.fullName')"
                :disabled="success"
            />
            <span v-show="formErrorFullName" class="ml-3">{{ $t('referralForm.fullNameMissing') }}</span>
            <b-form-input
                v-model="form.phoneNumber"
                type="text"
                class="input-control"
                required
                size="lg"
                maxlength="10"
                :placeholder="$t('referralForm.phoneNumber')"
                :disabled="success || (form.fullName.length < 2 || formErrorFullName)"
            />
            <span v-show="invalidPhoneNumber || !validatePhoneRegex()" class="ml-3">{{ $t('popup.phoneError') }}</span>
            <b-select
                v-model="form.timeFrame"
                class="input-control"
                :placeholder="$t('referralForm.preferredTimeFrame')"
                :disabled="success || (form.phoneNumber.length < 10 || (invalidPhoneNumber && formErrorFullName))"
            >
                <option disabled value="">{{ $t('popup.timeFramePrefer') }}</option>
                <option
                    v-for="timeFrame in timeFrameOptions"
                    :key="timeFrame.label"
                    :value="timeFrame.label"
                >{{ timeFrame.label }}</option>
            </b-select>
            <span v-show="formErrorTimeFrame" class="ml-3">{{ $t('referralForm.timeframeError') }}</span>
            <router-link v-slot="{ href }" to="/Πολιτική Προστασίας Προσωπικών Δεδομένων.pdf" target="_blank">
                <a :href="href">
                    <pre class="privacy-policy mt-4">{{ $t('privacyPolicy') }}</pre>
                </a>
            </router-link>
            <div class="text-center">
                <button type="submit" class="submit" :disabled="success || disableSubmit" @click="submit">{{ $t('referralForm.submit') }}</button>
            </div>
            <div v-show="success" class="sucess">{{ $t('referralForm.success') }}</div>
            <router-link v-slot="{ href }" to="/Όροι & Προϋποθέσεις - Σελίδα Συστηνόμενου.pdf" target="_blank">
                <a :href="href">
                    <div class="terms mt-3">
                        {{ $t('terms') }}
                    </div>
                </a>
            </router-link>
        </div>
    </div>
</template>

<script>
    import potentialCustomerService from '@/services/potential-customer-service'
    import referredService from '@/services/referred-service'
    import phoneService from '@/services/phone-service'

    export default {
        data() {
            return {
                form: {
                    fullName: '',
                    phoneNumber: '',
                    timeFrame: '',
                    urlCode: '',
                    email: null
                },
                invalidPhoneNumber: false,
                formErrorFullName: false,
                formErrorTimeFrame: false,
                timeFrameOptions: [],
                success: false,
                submissionError: '',
                disableSubmit: true
            }
        },
        watch: {
            'form.fullName'() {
                this.formErrorFullName = !this.validateFullName()
            },
            'form.timeFrame'() {
                this.formErrorTimeFrame = this.form.timeFrame.length === 0
                if (!this.formErrorTimeFrame && !this.formErrorFullName && !this.invalidPhoneNumber) {
                    this.disableSubmit = false
                }
            }
        },
        created() {
            this.form.urlCode = this.$route.params.code
            potentialCustomerService.getTimeFrames().then(res => {
                this.timeFrameOptions = res.content
            })
        },
        methods: {
            async submit() {
                this.resetFormErrors()
                if (!await this.validateForm()) {
                    return
                }
                this.showError('')
                const isUnique = await referredService.isUnique(this.form.phoneNumber)
                if (!isUnique.content) {
                    this.showError('Έχετε ήδη δηλώσει συμμετοχή στην ενέργεια «Έχεις φίλους; Κερδίζεις!», σας ευχαριστούμε!')
                    return
                }
                referredService.referred(this.form).then(resp => {
                    this.success = true
                }).catch(_ => {
                    this.showError('Κατι πήγε στραβά')
                })
            },
            validatePhone() {
                return phoneService.isValid(this.form.phoneNumber)
            },
            async validateForm() {
                if (this.form.fullName.length < 2) {
                    this.formErrorFullName = true
                    return false
                }
                const validPhone = this.isNumber(this.form.phoneNumber) && (await this.validatePhone()).content
                if (!validPhone) {
                    this.invalidPhoneNumber = true
                    return false
                }
                if (this.form.timeFrame.length === 0) {
                    this.formErrorTimeFrame = true
                    return false
                }
                return true
            },
            resetFormErrors() {
                this.invalidPhoneNumber = false
                this.formErrorFullName = false
                this.formErrorTimeFrame = false
            },
            isNumber(phone) {
                const reg = /\d{10}$/
                if (!phone.match(reg)) {
                    return false
                }
                return true
            },
            validateFullName() {
                if (this.form.fullName.length < 2) {
                    return false
                }

                return true
            },
            validatePhoneRegex() {
                const reg = /\d{10}$/
                if (this.form.phoneNumber.length > 2 && !this.form.phoneNumber.match(reg)) {
                    return false
                }
                return true
            },
            showError(error) {
                this.submissionError = error
                // setTimeout(() => { this.submissionError = null }, 12000)
            }
        }
    }
</script>

<style scoped>
.container-box {
    width: 100%;
    background: rgba(255, 255, 255, .74);
    backdrop-filter: blur(13px);
    border-radius: 27px;
    box-shadow: 0px 3px 6px #00000029;
    padding-bottom: 50px;
    padding: 2.3rem 2.3rem 1rem 2.3rem;
}
.text {
    font-size: 2rem;
}
.input-control {
    height: 65px;
    border-radius: 8px;
    font-size: 2rem;
    width: 100%;
    border: none;
    margin-top: 1.5rem;
}
.input-control:focus-visible {
    outline: none;
}
.input-control::placeholder {
    color: rgb(139, 139, 139, .6)!important;
    font-family: 'RobotoRegular';
}
.input-control:disabled {
    background: rgb(143, 143, 143);
    opacity: .6;
}
.input-control:disabled::placeholder, select:disabled {
    color: rgb(207, 207, 207)!important;
}
.submit {
    background: #004996;
    color: #fff;
    font-size: 1.875rem;
    border-radius: 8px;
    border: none;
    font-weight: bold;
    padding: 5px 30px;
    margin-top: 1rem;
    transition: all 0.15s ease-in-out;
    box-shadow: 0px 3px 6px #0000005E;
}
.submit:hover {
    background-color: #0660c0;
}
.submit:active {
    transform: scale(0.9)
}
.submit:disabled {
    background: grey;
    opacity: .3;
}
.submit:focus-visible {
    outline: none;
}
.privacy-policy {
    text-decoration: underline;
    font-size: .8rem;
    text-align: center;
    text-decoration-skip-ink: none;
    font-family: 'RobotoRegular';
}
.terms {
    text-decoration: underline;
    font-size: 1.125rem;
}
span {
    color: #a70000;
}
a, a:hover {
    text-decoration: none;
    color: inherit;
}
.sucess {
    text-align: center;
    margin-top: 1rem;
    font-size: 1.2rem;
    font-weight: bold;
}
.error {
    color: #a70000;
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
}
.input-control::placeholder {
    color: #8B8B8B;
    font-family: 'RobotoRegular';
}
@media screen and (max-width: 1320px) {
    .text {
        font-size: 1.8rem;
    }
    .input-control {
        font-size: 1.6rem;
        margin-top: 1.6rem;
    }
    span {
        font-size: .8rem;
    }
    .privacy-policy {
        font-size: 1rem;
    }
    .terms {
        font-size: 1.25rem;
    }
}
@media screen and (max-width: 1150px) {
    .text {
        font-size: 1.4rem;
    }
    .input-control {
        font-size: 1.2rem;
        margin-top: 1.6rem;
    }
    span {
        font-size: .7rem;
    }
    .container-box {
        padding: 2rem 2rem 1.2rem 2rem;
    }
    .privacy-policy {
        font-size: 0.7rem;
    }
    .terms {
        font-size: .95rem;
    }

}
@media screen and (max-width: 1490px) {
    .text {
        font-size: 1.8rem;
    }
}
@media screen and (max-width: 728px) {
    .container-box {
        padding: 1rem 2rem 1.2rem 2rem;
    }
    .text {
        font-size: .9rem;
    }
    .submit {
        font-size: .9rem;
        margin-top: 0px;
    }
    .input-control {
        font-size: 1rem;
        height: 35px;
        margin-top: .7rem;
    }
    .terms {
        font-size: .8rem;
    }
}

@media screen and (min-height: 789px) {
    .text {
        font-size: 1.6rem;
    }
}
</style>
